<template>
  <el-dialog title="详情" :visible.sync="visible" :append-to-body="true" width="60%">
    <div class="ac_tabs-contain">
      <div class="title-box">基本信息</div>
      <el-descriptions :column="1">
        <el-descriptions-item label="优惠券名称">{{ info.couponName }}</el-descriptions-item>
        <el-descriptions-item label="优惠券id">{{ info.couponId }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{ info.couponType }}</el-descriptions-item>
        <el-descriptions-item label="面值">{{ info.faceValue }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ info.couponStatus }}</el-descriptions-item>
        <el-descriptions-item label="有效期">{{ info.date }}</el-descriptions-item>
        <el-descriptions-item label="归属礼包">
          {{ info.giftName ? info.giftName : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="所属供应商">
          <div style="width: 100%" v-if="Array.isArray(info.merchantNameList)">
            <el-tag
              v-for="merchan in info.merchantNameList"
              :key="merchan"
              style="margin-right: 5px; margin-bottom: 5px"
            >
              {{ merchan }}
            </el-tag>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ info.creatTime }}</el-descriptions-item>
        <el-descriptions-item label="扫码补票是否可用">
          {{ info.driverUser ? '是' : '否' }}
        </el-descriptions-item>

        <el-descriptions-item label="优惠券承担方">
          <template v-if="info.responsible === 1">三方共补</template>

          <template v-if="info.responsible === 2">平台独补</template>

          <template v-if="info.responsible === 3">平台供应商双方共补</template>
        </el-descriptions-item>

        <el-descriptions-item label="不可用日期">
          <div style="width: 100%">
            <el-tag
              v-for="tag in disableDateArr"
              :key="tag"
              style="margin-right: 5px; margin-bottom: 5px"
            >
              {{ tag }}
            </el-tag>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <div class="title-box">使用</div>
      <el-descriptions :column="1">
        <el-descriptions-item label="总发行量">{{ info.totalNum }}</el-descriptions-item>
        <el-descriptions-item label="剩余">{{ info.remainNum }}</el-descriptions-item>
        <el-descriptions-item label="可用业务">{{ info.bu }}</el-descriptions-item>
        <el-descriptions-item
          label="可用线路"
          :contentStyle="{ maxHeight: '200px', overflow: 'auto' }"
        >
          {{ info.useLine }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-dialog>
</template>

<script>
  import { getCouponDetailsById } from '@/api/marketing/coupon-api'
  import dayjs from 'dayjs'
  export default {
    name: 'couponPkgDetails',
    data() {
      return {
        visible: false,
        info: {}
      }
    },
    computed: {
      // 不可用日期
      disableDateArr() {
        if (this.info.disableDate && this.info.disableDate.length > 0) {
          const dateArr = []
          this.info.disableDate.forEach((item) => {
            dateArr.push(...item.day)
          })
          if (dateArr.length > 0) {
            let relArr = Array.from(new Set(dateArr))
            relArr = relArr.sort((a, b) => {
              return dayjs(a).valueOf() - dayjs(b).valueOf()
            })
            return relArr
          }
          return dateArr
        }
        return []
      }
    },
    methods: {
      init(id) {
        this.visible = true
        this.getDetails(id)
      },
      async getDetails(id) {
        await getCouponDetailsById(id).then((resp) => {
          this.info = resp.data
        })
      }
    }
  }
</script>

<style lang="scss">
  .title-box {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }
  .ac_tabs-contain {
    padding-left: 20px;
  }
</style>
